import { render, staticRenderFns } from "./DropElement.vue?vue&type=template&id=50217468&scoped=true&"
import script from "./DropElement.vue?vue&type=script&lang=js&"
export * from "./DropElement.vue?vue&type=script&lang=js&"
import style0 from "./DropElement.vue?vue&type=style&index=0&id=50217468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50217468",
  null
  
)

export default component.exports